import { defineAction } from 'redux-define';

import { SUCCESS, ERROR, PENDING } from '../../../utils/const';

const ADD_NOTIFICATION = defineAction('ADD_NOTIFICATION', [SUCCESS, ERROR, PENDING]);
const REMOVE_NOTIFICATION = defineAction('REMOVE_NOTIFICATION', [SUCCESS, ERROR, PENDING]);

export { ADD_NOTIFICATION, REMOVE_NOTIFICATION };
